<template>
  <v-flex wrap class="container">
    <textarea-field
      v-model="form.eventClosed"
      :validator="vs.eventClosed"
      :label="adminText('workflowsAll.event_closed_0a46550', 'Event closed')"
    />
  </v-flex>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'closed-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        eventClosed: 'Applications for this event are closed.',
      },
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted () {
    if(this.initialValues && this.initialValues.eventClosed) {
      this.form = {...this.form, ...this.initialValues}
    }
    this.$emit('values', this.form)
  },
}
</script>

<style scoped>
  .container {
    max-width: 672px ;
    margin: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }
</style>
